/**
 * A monotonically increasing generation invalidates saves begun for an older
 * workshop session. It deliberately has no React dependency so it is easy to
 * test and safe to consult after an awaited network request.
 */
export function createGuestSessionGuard() {
  let generation = 0;
  return {
    current: () => generation,
    reset: () => { generation += 1; return generation; },
    isCurrent: (candidate) => candidate === generation,
  };
}
